import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 50rem 0;
  max-width: 1440rem;
  width: 100%;

  ${respondTo.smallLaptop`
    padding: 50rem 15rem;
  `}

  ${respondTo.smallTablet`
    padding: 20rem 15rem;
  `}
`;

export const Heading = styled.h2`
  font-size: 40rem;
  font-weight: 300;
  color: ${COLORS.BLACK};

  ${respondTo.smallTablet`
    font-size: 30rem;
  `}
`;

export const FirstRow = styled.div`
  margin-bottom: 20rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${respondTo.smallTablet`
    flex-direction: column;
    align-items: flex-start;
    gap: 20rem;
  `}
`;

export const InputWrapper = styled.div`
  width: 300rem;

  ${respondTo.smallTablet`
    width: 100%;
  `}
`;

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 30rem;

  ${respondTo.smallTablet`
    width: 100%;
    max-width: 100%;
  `}

  ${respondTo.smallPhone`
    flex-direction: column;
    align-items: flex-start;
    gap: 20rem;
  `}
`;
